import { Component } from '@angular/core';
import { ComDatePasseExacteComponent } from '@kv-common-components/kv-common-components';

@Component({
    selector: 'app-date-passe-exacte-component',
    templateUrl: './date-passe-exacte.component.html',
    styleUrls: ['./date-passe-exacte.component.scss'],
})
export class DatePasseExacteComponent extends ComDatePasseExacteComponent {}
